import { render, staticRenderFns } from "./SuspendComponent.vue?vue&type=template&id=c695c1b6&scoped=true"
var script = {}
import style0 from "./SuspendComponent.vue?vue&type=style&index=0&id=c695c1b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c695c1b6",
  null
  
)

export default component.exports